const accordionInjectionKey = Symbol("accordion");
const tabsInjectionKey = Symbol("tabs");

export { accordionInjectionKey, tabsInjectionKey };
